// extracted by mini-css-extract-plugin
export default {"cronometro":"Cronometro_cronometro__qQpWB","relogioWrapper":"Cronometro_relogioWrapper__uscXJ","titulo":"Cronometro_titulo__kppwB"};